export default "skymp5-front/339cb8cb3eead92abe5e7148ed5942b3.gif";